import { isGinioneDomain } from '@/utils/clerkApp';

const normalizeUrl = (url?: string): string => (url ?? '').trim().replace(/\/+$/, '');

const resolveDomainUrl = (urls: { bloom?: string; ginione?: string; legacy?: string }): string => {
  const bloomUrl = normalizeUrl(urls.bloom);
  const ginioneUrl = normalizeUrl(urls.ginione);
  const legacyUrl = normalizeUrl(urls.legacy);
  const onGinioneDomain = isGinioneDomain();

  if (onGinioneDomain && ginioneUrl) {
    return ginioneUrl;
  }
  if (!onGinioneDomain && bloomUrl) {
    return bloomUrl;
  }

  if (legacyUrl) {
    return legacyUrl;
  }

  console.warn(
    '[apiUrl] No base URL configured (all NEXT_PUBLIC_* API/WS url env vars are empty/unset).',
    {
      onGinioneDomain,
      hasBloomUrl: !!bloomUrl,
      hasGinioneUrl: !!ginioneUrl,
      hasLegacyUrl: !!legacyUrl,
    },
  );
  return '';
};

export const getApiBaseUrl = (): string => {
  return resolveDomainUrl({
    bloom: process.env.NEXT_PUBLIC_BACKEND_API_URL_BLOOM,
    ginione: process.env.NEXT_PUBLIC_BACKEND_API_URL_GINIONE,
    legacy: process.env.NEXT_PUBLIC_BACKEND_API_URL,
  });
};

export const getWebsocketUrl = (): string => {
  return resolveDomainUrl({
    bloom: process.env.NEXT_PUBLIC_WEBSOCKET_URL_BLOOM,
    ginione: process.env.NEXT_PUBLIC_WEBSOCKET_URL_GINIONE,
    legacy: process.env.NEXT_PUBLIC_WEBSOCKET_URL,
  });
};
